var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-button',{attrs:{"variant":"show-more","disabled":_vm.fetchingMore},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.fetchingMore)?_c('TheSpinner'):_c('span',{staticClass:"ml-2 text-sm font-bold"},[_vm._v("Show More")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }